import { isSupportPPTType } from '@editor/src/js/constants/import';

/**
 * dragover过程中没有files，drop事件有files和items
 * @param event
 * @param customJudgment
 * @returns
 */
export const dragBaseLogic = (event: DragEvent, customJudgment?) => {
    if (!event?.dataTransfer?.items?.length && !event?.dataTransfer?.files?.length) return [];
    const { files, items } = event.dataTransfer;
    return customJudgment(files?.length ? files : items);
};

export const preventDefaultIfTypeIsFile = (event) => {
    if (event?.dataTransfer?.items?.[0]?.kind === 'file'
        || (
            ((window as any)?.browser?.browser?.msie || (window as any)?.browser?.browser?.safari)
            && event?.dataTransfer
        )
    ) {
        event.preventDefault();
        return true;
    }
    return false;
};

/**
 * 用于 drop 事件后过滤非.ppt/.pptx文件
 * @param {*} event
 * @returns
 */
export const getDragPPTList = (event: DragEvent) => dragBaseLogic(
    event,
    (list: DataTransferItemList) => Array.from(list).filter(item => isSupportPPTType({ type: item.type, name: '' })),
);
